import { createApi } from "@reduxjs/toolkit/query/react"
import {
  OrganisationDto,
  OrganisationQueryParams,
  OrganisationsDto,
  OrganisationsQueryParams,
} from "@custom-types/organisation"
import { authQuery } from "./authQuery"
import { ValidationErrorResponse } from "@custom-types/common"

export const organisationsApi = createApi({
  reducerPath: "organisationsApi",
  baseQuery: authQuery,
  endpoints: (builder) => ({
    getOrganisations: builder.query<OrganisationsDto, OrganisationsQueryParams>({
      query: ({ includeUsers = true, includeContracts = true, includeDivisions = true }) => ({
        url: "/organisations",
        params: {
          include_users: includeUsers,
          include_contracts: includeContracts,
          include_divisions: includeDivisions,
        },
      }),
    }),
    getOrganisationByKey: builder.query<OrganisationDto, OrganisationQueryParams>({
      query: ({ key, includeUsers = true, includeContracts = true, includeDivisions = true }) => ({
        url: `/organisations/${key}`,
        params: {
          include_users: includeUsers,
          include_contracts: includeContracts,
          include_divisions: includeDivisions,
        },
      }),
    }),
    postOrganisation: builder.mutation<
      OrganisationDto | ValidationErrorResponse | string,
      OrganisationDto
    >({
      query: (payload) => ({
        url: "/organisations",
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    putOrganisation: builder.mutation<
      OrganisationDto | ValidationErrorResponse | string,
      OrganisationDto
    >({
      query: (payload) => ({
        url: `/organisations/${payload.key}`,
        method: "PUT",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    deleteOrganisation: builder.mutation<ValidationErrorResponse | string, string>({
      query: (key) => ({
        url: `/organisations/${key}`,
        method: "DELETE",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
  }),
})

export const {
  useGetOrganisationsQuery,
  useGetOrganisationByKeyQuery,
  usePostOrganisationMutation,
  usePutOrganisationMutation,
  useDeleteOrganisationMutation,
} = organisationsApi
